import React from "react";
import { useData, useField } from "state/hooks";
import DefaultFilePreview from "components/file/FilePreview";
import Popover from "components/Popover";
import DeviceSelectList from "./../DeviceSelectList";
import { targetDevices } from "config/devices";
import "./style.css";
import IconButton from "components/IconButton";
import Button from "components/Button";

//import PropTypes from 'prop-types';

function SelectDeviceContainer(props) {
    const { type, id, onChange } = props;
    const { value } = useField(type, id, "target_device");
    return <SelectDevice value={value} onChange={onChange} />;
}

function SelectDevice(props) {
    const { value, label, onChange } = props;
    const handleChange = (e, value) => onChange(value);
    return (
        <Popover
            trigger={({ onClick }) => (
                <div className={"device-select"} onClick={onClick}>
                    {targetDevices[value] || label}
                </div>
            )}
            content={({ onClose }) => (
                <DeviceSelectList
                    onChange={handleChange}
                    onMenuClose={onClose}
                />
            )}
        />
    );
}

SelectDevice.defaultProps = {
    label: "Wybierz",
};

function MediaSetItem(props) {
    const { id, onOpenLibrary, onRemove, onChangeItem, FilePreview } = props;
    const data = useData(props);
    const path = [props.type, props.id, "media"].join("/");
    const mediaId = data?.media?.[0];

    const { type: mediaType, file } = useData({
        type: "cms.media",
        id: mediaId,
    });

    const fileName = file ? file.split("/").pop() : null;

    const handleChangeDevice = (device) => {
        onChangeItem(id, { target_device: device });
    };

    return (
        <div className={"media-set-item cols gap-xs"}>
            <div className={"thumb"}>
                <FilePreview file={file} mediaType={mediaType} />
            </div>
            <div className={"rows rows-left gap-xxs grow"}>
                <div className={"file-name"}>{fileName}</div>
                <div>
                    <SelectDeviceContainer
                        type={"cms.media-set-item"}
                        id={id}
                        onChange={handleChangeDevice}
                    />
                </div>
            </div>
            <div className={"cols cols-2 gap-xs"}>
                <div className={"cols cols-middle"}>
                    <IconButton
                        icon={"mui-delete"}
                        onClick={() => onRemove(id)}
                    />
                    <IconButton
                        icon={"mui-search"}
                        onClick={() => onOpenLibrary(path, true)}
                    />
                </div>
            </div>
        </div>
    );
}

MediaSetItem.defaultProps = {
    type: "cms.media-set-item",
    FilePreview: DefaultFilePreview,
};

export function MediaSet(props) {
    const { items, onOpenLibrary, onCreate, onChangeItem, onRemove } = props;

    return (
        <div className={"rows pad-md gap-md"}>
            <div className={"cols cols-left"}>
                <Button onClick={onCreate}>Dodaj</Button>
            </div>
            <div className={"rows gap-xs"}>
                {items.map((item) => (
                    <MediaSetItem
                        key={item}
                        id={item}
                        onRemove={onRemove}
                        onChangeItem={onChangeItem}
                        onOpenLibrary={onOpenLibrary}
                    />
                ))}
            </div>
        </div>
    );
}

MediaSet.propTypes = {};

MediaSet.defaultProps = {
    items: [],
};

export default MediaSet;
